<ul class="nav nav-tabs">
  <div class="d-flex">
    @for (item of uiTabs | keyvalue; track $index) {
      <li class="nav-item" (click)="changeTab(item.value)">
        <a class="nav-link" [class.active]="selectedTab === item.value">{{
          item.value
        }}</a>
      </li>
    }
  </div>
</ul>
<div class="tab-content">
  @if (selectedTab === uiTabs.tab10) {
    <div
      class="tab-pane"
      [ngClass]="selectedTab === uiTabs.tab10 ? 'active' : ''"
    >
      <gtapp-response-type></gtapp-response-type>
    </div>
  }
  @if (selectedTab === uiTabs.tab11) {
    <div
      class="tab-pane"
      [ngClass]="selectedTab === uiTabs.tab11 ? 'active' : ''"
    >
      <gtapp-service-type></gtapp-service-type>
    </div>
  }
  @if (selectedTab === uiTabs.tab12) {
    <div
      class="tab-pane"
      [ngClass]="selectedTab === uiTabs.tab12 ? 'active' : ''"
    >
      <gtapp-incident-type></gtapp-incident-type>
    </div>
  }
</div>
